import React, { useEffect, useState } from 'react';
import styles from './alexmattosreal.module.scss';
import BackgroundLinks from './src/background-links5.png';
import BannerAgendamento from './src/1.png';
import BannerContatos from './src/2.png';
import BannerLocalizacao from './src/3.png';
import BannerSaintGermain from './src/4.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'alexmattosbarber@gmail.com';
const WHATSAPP_NUMBER = '5511988882281';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const AGENDAMENTO_MSG = 'Olá! Vim pelo link na bio e gostaria de agendar um horário.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const AGENDAMENTO_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(AGENDAMENTO_MSG)}`;
const INSTAGRAM_URL =
    'https://www.instagram.com/alexmattos.real?utm_source=ig_web_button_share_sheet&stkn=ZDNlZDc0MzIxNw==';
const MAPS_URL = 'https://maps.app.goo.gl/pK8QcX8F8hT6Kj8N9';
const ICON_COLOR = '#ffffff';

type SoonCard = {
    image: string;
    brand: string;
    modal: 'soon';
};

type LinkCard = {
    image: string;
    alt: string;
    link: string;
    modal?: false;
};

type CardItem = SoonCard | LinkCard;

const banners: CardItem[] = [
    {
        image: BannerAgendamento,
        alt: 'Agendamento',
        link: AGENDAMENTO_URL,
    },
    {
        image: BannerContatos,
        alt: 'Contatos e parcerias',
        link: `mailto:${EMAIL}`,
    },
    {
        image: BannerLocalizacao,
        alt: 'Localização',
        link: MAPS_URL,
    },
    {
        image: BannerSaintGermain,
        brand: 'Saint Germain',
        modal: 'soon',
    },
];

const Alexmattosreal: React.FC = () => {
    const [soonOpen, setSoonOpen] = useState(false);

    useEffect(() => {
        if (!soonOpen) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setSoonOpen(false);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [soonOpen]);

    return (
        <div className={styles.alexmattosreal}>
            <div className={styles.main}>
                <img
                    className={styles.cardImage}
                    src={BackgroundLinks}
                    alt="Alex Mattos — 16 anos realçando a beleza masculina"
                    decoding="async"
                />
                <div className={styles.content}>
                    <div className={styles.socialRow}>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="WhatsApp"
                        >
                            <WhatsappIcon height="26" color={ICON_COLOR} />
                        </a>
                        <a
                            href={`mailto:${EMAIL}`}
                            className={styles.socialLink}
                            aria-label="E-mail"
                        >
                            <svg
                                height="22"
                                width="22"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path
                                    fill={ICON_COLOR}
                                    d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                />
                            </svg>
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <InstagramIcon height="22" color={ICON_COLOR} />
                        </a>
                    </div>
                    {banners.map((banner) =>
                        banner.modal ? (
                            <button
                                type="button"
                                key={banner.brand}
                                className={styles.contentLink}
                                onClick={() => setSoonOpen(true)}
                                aria-label={`Abrir ${banner.brand}`}
                            >
                                <img
                                    className={styles.contentImage}
                                    src={banner.image}
                                    alt={banner.brand}
                                    decoding="async"
                                />
                            </button>
                        ) : (
                            <a
                                key={banner.alt}
                                href={banner.link}
                                target={banner.link.startsWith('mailto:') ? undefined : '_blank'}
                                rel={banner.link.startsWith('mailto:') ? undefined : 'noopener noreferrer'}
                                className={styles.contentLink}
                            >
                                <img
                                    className={styles.contentImage}
                                    src={banner.image}
                                    alt={banner.alt}
                                    decoding="async"
                                />
                            </a>
                        )
                    )}
                </div>
            </div>

            {soonOpen && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setSoonOpen(false)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="alexmattosreal-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setSoonOpen(false)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                        <p className={styles.modalEyebrow}>Cupom exclusivo</p>
                        <h2 id="alexmattosreal-modal-title" className={styles.modalBrand}>
                            Saint Germain
                        </h2>
                        <p className={styles.modalText}>
                            Este cupom estará disponível em breve.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Alexmattosreal;
